var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("dl", [
      _c("dt", [_c("Qnumber")], 1),
      _vm._v(" "),
      _c("dd", [_vm._v(_vm._s(_vm.quasution))]),
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "modal__shindanQ" }, [
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.clickAnswer(0)
            },
          },
        },
        [
          _c("label", [
            _c("input", { attrs: { type: "checkbox", value: "c[]" } }),
            _vm._v(_vm._s(_vm.answer1)),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.clickAnswer(1)
            },
          },
        },
        [
          _c("label", [
            _c("input", { attrs: { type: "checkbox", value: "c[]" } }),
            _vm._v(_vm._s(_vm.answer2)),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }